import React from 'react';
import ReactApexChart from "react-apexcharts";
import { Typography, Card } from "antd";
import { MinusOutlined } from "@ant-design/icons";
import { formatCurrency } from '../../../helper/formatCurrency';


function Income(props) {

    const { data } = props;

    const { Title, Paragraph } = Typography;

    const lineChart = {
        series: [
            {
                name: "Income",
                data: data?.graph_income?.data,
                offsetY: 0,
            },
        ],

        options: {
            chart: {
                width: "100%",
                height: 350,
                type: "area",
                toolbar: {
                    show: false,
                },
            },

            legend: {
                show: false,
            },

            dataLabels: {
                enabled: false,
            },
            stroke: {
                curve: "smooth",
            },

            yaxis: {
                labels: {
                    style: {
                        fontSize: "14px",
                        fontWeight: 600,
                        colors: ["#8c8c8c"],
                    },
                    formatter: function (val) {
                        return formatCurrency(parseInt(val));
                    },
                },
            },

            xaxis: {
                labels: {
                    style: {
                        fontSize: "14px",
                        fontWeight: 600,
                        colors: "#8c8c8c"
                    },
                },
                categories: data?.graph_income?.labels,
            },

            tooltip: {
                y: {
                    formatter: function (val) {
                        return formatCurrency(parseInt(val));
                    },
                },
            },
        },
    };

    return (
        <div>
            <Card>
                <div className="linechart">
                    <div>
                        <Title level={5}>Income</Title>
                        <Paragraph className="lastweek">
                            than last week <span className="bnb2">-%</span>
                        </Paragraph>
                    </div>
                </div>

                <ReactApexChart
                    className="full-width"
                    options={lineChart.options}
                    series={lineChart.series}
                    type="area"
                    height={350}
                    width={"100%"}
                />

                <div className='grid grid-cols-2 gap-4 p-4'>
                    <div className='col-span-1 flex justify-center flex-col items-center'>
                        <h1 className="font-bold text-lg">{formatCurrency(parseInt(data?.average_overview?.averageIncomePerDay || 0))}</h1>
                        <p className="text-sm">Avg. Income/day</p>
                    </div>
                    <div className='col-span-1 flex justify-center flex-col items-center'>
                        <h1 className="font-bold text-lg">{formatCurrency(parseInt(data?.average_overview?.averageIncomePerWeek || 0))}</h1>
                        <p className="text-sm">Avg. Income/week</p>
                    </div>
                    {/* <div className='col-span-1'>
                        <h1 className="font-bold text-lg">Rp 1.000.000</h1>
                        <p className="text-sm">Avg. Income/person</p>
                    </div>
                    <div className='col-span-1'>
                        <h1 className="font-bold text-lg">Rp 1.000.000</h1>
                        <p className="text-sm">Avg. Income/month</p>
                    </div> */}
                </div>
            </Card>
        </div>
    );
}

export default Income;